export const NoAuthWebUrl = {
  login: process.env.REACT_APP_LOGIN_URL,
  login_token: process.env.REACT_APP_LOGIN_URL + '/:token',
  register: '/auth/register',
  register_token: '/auth/register/:token',
};
